module.exports = __webpack_public_path__ + "img/cb3.c243a6cd.jpg";